import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

// Owner's WhatsApp number — international format, digits only
const WHATSAPP_NUMBER = "919371212211";

const messageFor = (pathname, params) => {
  const dest = params.get("destination");
  const veh = params.get("vehicle");
  if (dest) return `Hi Shaurya Travels, I'm interested in the ${dest} package. Please share details.`;
  if (veh) return `Hi Shaurya Travels, I'd like to enquire about the ${veh}.`;
  if (pathname.startsWith("/destinations")) return "Hi Shaurya Travels, I want to know more about your destination packages.";
  if (pathname.startsWith("/vehicles")) return "Hi Shaurya Travels, I'd like to enquire about your vehicle services.";
  if (pathname.startsWith("/gallery")) return "Hi Shaurya Travels, I'd like to know about your travel services.";
  return "Hi Shaurya Travels, I'd like to plan a journey. Please share details.";
};

const WhatsAppFab = () => {
  const location = useLocation();
  const [params] = useSearchParams();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // hide on admin pages
    setVisible(!location.pathname.startsWith("/admin"));
  }, [location.pathname]);

  if (!visible) return null;

  const msg = messageFor(location.pathname, params);
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[100] flex items-center gap-3 pl-3 pr-4 py-3 bg-[#25D366] hover:bg-[#1ebe57] text-white rounded-full shadow-2xl transition-transform duration-300 hover:scale-105 group"
    >
      <span className="relative flex h-11 w-11 items-center justify-center rounded-full bg-white/15">
        <span className="absolute inset-0 rounded-full bg-white/40 animate-ping opacity-50" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor"
          className="h-7 w-7 relative"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.058-.832-2.27-.143-.286-.16-.43-.46-.43H12c-.4 0-.7.115-1 .43-.832.945-1.16 1.892-1.16 3.038 0 1.146.46 2.27 1.16 3.317.86 1.29 2.05 2.522 3.35 3.41 1.6 1.092 3.48 1.836 5.4 1.836.97 0 2.05-.143 2.85-.717.86-.602 1.32-1.55 1.32-2.583 0-.86-.43-1.5-1.6-2.058-.4-.215-1.3-.501-1.7-.501Z"/>
          <path d="M16.013 2.667c-7.36 0-13.333 5.973-13.333 13.333a13.27 13.27 0 0 0 1.787 6.667l-1.882 6.866 7.04-1.84a13.27 13.27 0 0 0 6.388 1.63c7.36 0 13.333-5.973 13.333-13.333S23.373 2.667 16.013 2.667Zm0 24.4a11.05 11.05 0 0 1-5.633-1.547l-.405-.24-4.18 1.093 1.12-4.08-.265-.421A11.012 11.012 0 0 1 4.987 16c0-6.073 4.94-11.013 11.013-11.013S27.013 9.927 27.013 16s-4.94 11.067-11 11.067Z"/>
        </svg>
      </span>
      <span className="hidden sm:flex flex-col leading-tight pr-1">
        <span className="text-[10px] uppercase tracking-[0.2em] opacity-90">Chat with us</span>
        <span className="text-sm font-medium">+91 9371212211</span>
      </span>
    </a>
  );
};

export default WhatsAppFab;
